export enum PopupActionType {

    OpenDeposit = 1,
    OpenPosition = 4,
    OpenSurvey = 6,
    ExecuteDeepLink = 7
}

export interface PopupNotification {

    Hyperlink: string;
    Id: number;
    Message: string;
    PopupActionType: PopupActionType;
    SymbolId: number;
    SymbolName: string;
}
